import React from 'react';
import { TopBar } from './components/TopBar';
import { HeroSection } from './components/HeroSection';
import { PainPoints } from './components/PainPoints';
import { ProductTomos } from './components/ProductTomos';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-[#0D0D0D]" data-id="element-0">
      <TopBar data-id="element-1" />
      <HeroSection data-id="element-2" />
      <PainPoints data-id="element-3" />
      <ProductTomos data-id="element-4" />
      <BonusSection data-id="element-5" />
      <PricingSection data-id="element-6" />
      <Testimonials data-id="element-7" />
      <FAQ data-id="element-8" />
      <FinalCTA data-id="element-9" />
      <Footer data-id="element-10" />
    </div>;
}